import * as Sentry from "@sentry/react";
import version from "@data/version.json";
import {BaseServices} from "./base";

const SENTRY_DSN: string = "https://06f272b748fa4d49d592129b71747f18@o1412937.ingest.us.sentry.io/4507044752392192";

export class ProductionServices extends BaseServices {
    initialise() {
        console.log("Initialising production services");
        Sentry.init({
            dsn: SENTRY_DSN,
            environment: window.location.host === "localhost" ? "development" : "production",
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: false
                }),
            ],
            release: version.version,
            // Performance Monitoring
            tracePropagationTargets: [/^https:\/\/wordland\.uk/],
            tracesSampleRate: 0.1,
            // Session Replay
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0
        });
        return Promise.resolve(true);
    }

    get name() {
        return "Production Service";
    }
}